import { init as initCollectionTabs } from './collection-tabs';
import { init as initCarousel } from './carousel';
import { init as initCarousel2 } from './carousel2';
import { init as initTestimonials } from './homepage-testimonials';
import { init as initCarouselSwatches } from './carousel-swatch';
import { init as initMoreToExplore } from './more-to-explore';
const logErrors = function(err) {
    console.error(err);
};
initCollectionTabs().catch(logErrors);
initCarousel().catch(logErrors);
initCarousel2().catch(logErrors);
initCarouselSwatches().catch(logErrors);
initTestimonials().catch(logErrors);
initMoreToExplore().catch(logErrors);
